export const playNotificationSound = (type) => {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    const ctx = new AudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.connect(gain);
    gain.connect(ctx.destination);

    const now = ctx.currentTime;

    if (type === 'success') {
      // Pleasant ascending chime (C5 -> C6)
      osc.type = 'sine';
      osc.frequency.setValueAtTime(523.25, now); // C5
      osc.frequency.exponentialRampToValueAtTime(1046.5, now + 0.1); // C6
      
      // Smooth envelope
      gain.gain.setValueAtTime(0.0, now);
      gain.gain.linearRampToValueAtTime(0.15, now + 0.05);
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.5);

      osc.start(now);
      osc.stop(now + 0.5);
    } else if (type === 'error') {
      // Distinct "Error" Buzz (Sawtooth wave for better audibility)
      osc.type = 'sawtooth';
      osc.frequency.setValueAtTime(440, now); // Start at A4
      osc.frequency.exponentialRampToValueAtTime(110, now + 0.4); // Drop quickly to A2

      // Sharp attack, quick decay
      gain.gain.setValueAtTime(0.1, now);
      gain.gain.exponentialRampToValueAtTime(0.01, now + 0.4);

      osc.start(now);
      osc.stop(now + 0.4);
    }

    // Cleanup context after sound finishes
    setTimeout(() => {
      if (ctx.state !== 'closed') ctx.close();
    }, 1000);

  } catch (e) {
    console.error('Audio playback failed', e);
  }
};

export const playCowMoo = () => {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    
    const ctx = new AudioContext();
    
    // Browser Policy Fix: Try to resume if suspended (requires interaction history)
    if (ctx.state === 'suspended') {
      ctx.resume().catch(e => console.warn("Audio Context resume failed", e));
    }
    
    // Create nodes for a rich, deep voice
    const osc1 = ctx.createOscillator(); // Main voice
    const osc2 = ctx.createOscillator(); // Sub-bass
    const gain = ctx.createGain();
    const filter = ctx.createBiquadFilter();
    const compressor = ctx.createDynamicsCompressor();

    const t = ctx.currentTime;
    const duration = 2.0;

    // Oscillator 1: Sawtooth for harmonics (buzzy vocal cord sound)
    osc1.type = 'sawtooth';
    // Pitch envelope: Raised slightly for laptop speakers (110Hz -> 130Hz -> 70Hz)
    osc1.frequency.setValueAtTime(110, t);
    osc1.frequency.linearRampToValueAtTime(130, t + 0.4); // "Mmm"
    osc1.frequency.exponentialRampToValueAtTime(70, t + duration); // "oooo"

    // Oscillator 2: Triangle for body/depth (better than sine for small speakers)
    osc2.type = 'triangle';
    osc2.frequency.setValueAtTime(108, t);
    osc2.frequency.linearRampToValueAtTime(128, t + 0.4);
    osc2.frequency.exponentialRampToValueAtTime(68, t + duration);

    // Filter: Lowpass to simulate the mouth closing/muffling
    filter.type = 'lowpass';
    filter.frequency.setValueAtTime(800, t); // Start open
    filter.frequency.exponentialRampToValueAtTime(200, t + duration); // Close down
    filter.Q.value = 1;

    // Gain Envelope (Volume shape) - Increased volume
    gain.gain.setValueAtTime(0, t);
    gain.gain.linearRampToValueAtTime(0.4, t + 0.5); // Slow attack "Mmmm"
    gain.gain.setValueAtTime(0.4, t + 1.0); // Sustain
    gain.gain.linearRampToValueAtTime(0, t + duration); // Release

    // Connect graph
    osc1.connect(filter);
    osc2.connect(filter);
    filter.connect(gain);
    gain.connect(compressor);
    compressor.connect(ctx.destination);

    // Play
    osc1.start(t);
    osc2.start(t);
    osc1.stop(t + duration);
    osc2.stop(t + duration);

    // Cleanup
    setTimeout(() => {
      if (ctx.state !== 'closed') ctx.close();
    }, (duration + 0.5) * 1000);

    console.log("🐄 Moo!");
  } catch (e) {
    console.error('Moo failed', e);
  }
};